import { PLAN_NAMES } from "../Pages/Plan/billingFormat.js";

const LIMIT_CODES = { plan_client_limit: "clients", plan_user_limit: "users", plan_feature_required: "feature" };

// DRF puede devolver el código suelto, dentro de `detail` o en un array de errores.
const findCode = (data) => {
  if (!data) return null;
  if (typeof data === "string") return LIMIT_CODES[data] ? data : null;
  if (Array.isArray(data)) return data.map(findCode).find(Boolean) || null;
  if (typeof data === "object") {
    if (LIMIT_CODES[data.code]) return data.code;
    return findCode(data.detail) || findCode(data.non_field_errors);
  }
  return null;
};

/**
 * `{ kind: "clients" | "users" | "feature", plan, planName, limit, detail, plans }` si el error de la API
 * es un límite de plan; `null` en cualquier otro caso. `plans`: planes que incluyen la funcionalidad.
 */
export const getPlanLimitError = (error) => {
  const data = error?.response?.data;
  const code = findCode(data);
  if (!code) return null;
  const payload = data && typeof data === "object" && !Array.isArray(data) ? data : {};
  return {
    kind: LIMIT_CODES[code],
    plan: payload.plan ?? null,
    planName: payload.plan_name ?? PLAN_NAMES[payload.plan] ?? null,
    limit: payload.limit ?? null,
    detail: payload.detail ?? null,
    plans: payload.plans ?? [],
  };
};

